import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import BrowserOnly from 'components/consumer/BrowserOnly';
import ProductListingPageContext from 'data-hooks/context/ProductListingPageContext';
import ProductListingPageWidgets from 'components/consumer/ProductListingPageWidgets';
import ProductListingPageDescription from './components/ProductListingPageDescription';
import DesktopProductListingSidebarFilters from './components/desktop/DesktopProductListingSidebarFilters';
import ProductListingSortBy from './components/ProductListingSortBy';
import DesktopShowHideFiltersButton from './components/desktop/DesktopShowHideFiltersButton';
import ProductListingResultsCount from './components/ProductListingResultsCount';
import DesktopProductListingSidebarContainer from './components/desktop/DesktopProductListingSidebarContainer';
import ProductListingLoadMoreButtons from './components/ProductListingLoadMoreButtons';
import ProductListingGrid from './components/ProductListingGrid';
import ProductListingPageName from './components/ProductListingPageName';
import useProductListingAnalytics from './hooks/useProductListingAnalytics';
import ProductListingPageTitleAndMetaTags from './components/ProductListingPageTitleAndMetaTags';
import MobileGridColumnToggle from './components/mobile/MobileGridColumnToggle';
import MobileProductListingFiltersButtonAndModal from './components/mobile/MobileProductListingFiltersButtonAndModal';
import DesktopProductListingColorFilter from './components/desktop/DesktopProductListingColorFilter';
const ProductListingPage = t0 => {
  const $ = _c(55);
  const {
    pageData,
    pageHeaderOverride,
    serverOwnsSeoTags: t1,
    sidebarHeader,
    variant
  } = t0;
  const serverOwnsSeoTags = t1 === undefined ? false : t1;
  const [isDesktopSidebarOpen, setIsDesktopSidebarOpen] = useState(true);
  useProductListingAnalytics(pageData);
  const {
    loading,
    isFinalProductCountKnown,
    pageName,
    totalProductCount
  } = pageData;
  if (loading) {
    return null;
  }
  let t2;
  if ($[0] !== serverOwnsSeoTags) {
    t2 = <ProductListingPageTitleAndMetaTags serverOwnsSeoTags={serverOwnsSeoTags} />;
    $[0] = serverOwnsSeoTags;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = variant === "advanced-search";
  const t4 = variant === "advanced-search";
  const t5 = !variant || variant !== "advanced-search";
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = classNames("px-3 py-4 space-y-1", "md:px-0 md:py-0 md:space-y-0", "md:items-center md:bg-white md:flex md:h-[53px] md:sticky md:z-[11] md:gap-5 md:justify-between", {
      "md:top-[55px]": t4,
      "md:top-[117px]": t5
    });
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = variant === "advanced-search";
  let t8;
  if ($[5] !== loading || $[6] !== pageName || $[7] !== t7) {
    t8 = <ProductListingPageName loading={loading} pageName={pageName} showPageNameWhileLoading={t7} />;
    $[5] = loading;
    $[6] = pageName;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = loading || !isFinalProductCountKnown;
  let t10;
  if ($[9] !== t9 || $[10] !== totalProductCount || $[11] !== variant) {
    t10 = <ProductListingResultsCount loading={t9} totalProductCount={totalProductCount} variant={variant} />;
    $[9] = t9;
    $[10] = totalProductCount;
    $[11] = variant;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setIsDesktopSidebarOpen(_temp);
    };
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== loading) {
    t12 = <DesktopShowHideFiltersButton loading={loading} onClick={t11} />;
    $[14] = loading;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10 || $[17] !== t12 || $[18] !== t8) {
    t13 = <div className="md:flex md:gap-5 md:items-center">{t8}{t10}{t12}</div>;
    $[16] = t10;
    $[17] = t12;
    $[18] = t8;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  let t15;
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = classNames("flex flex-row justify-between gap-3 py-3", "md:block md:gap-0 md:py-0");
    t15 = classNames("flex-1 flex gap-1", "md:flex-initial md:block md:gap-0");
    t16 = <MobileProductListingFiltersButtonAndModal />;
    $[20] = t14;
    $[21] = t15;
    $[22] = t16;
  } else {
    t14 = $[20];
    t15 = $[21];
    t16 = $[22];
  }
  let t17;
  if ($[23] !== pageHeaderOverride) {
    t17 = pageHeaderOverride ?? <><DesktopProductListingColorFilter /><ProductListingSortBy /></>;
    $[23] = pageHeaderOverride;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t17) {
    t18 = <div className={t15}>{t16}<div className="flex-1 md:flex-initial md:flex md:flex-row md:gap-4 md:items-center">{t17}</div></div>;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <MobileGridColumnToggle />;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t18) {
    t20 = <div className={t14}>{t18}{t19}</div>;
    $[28] = t18;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t13 || $[31] !== t20 || $[32] !== t6) {
    t21 = <div className={t6}>{t13}{t20}</div>;
    $[30] = t13;
    $[31] = t20;
    $[32] = t6;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== variant) {
    t22 = <DesktopProductListingSidebarFilters variant={variant} />;
    $[34] = variant;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== isDesktopSidebarOpen || $[37] !== sidebarHeader || $[38] !== t22) {
    t23 = <div className="hidden md:block"><DesktopProductListingSidebarContainer isOpen={isDesktopSidebarOpen}>{sidebarHeader}{t22}</DesktopProductListingSidebarContainer></div>;
    $[36] = isDesktopSidebarOpen;
    $[37] = sidebarHeader;
    $[38] = t22;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <ProductListingGrid />;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="md:space-y-8 md:mb-8 md:flex-1">{t24}<BrowserOnly><ProductListingLoadMoreButtons /></BrowserOnly><ProductListingPageDescription /></div>;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t23) {
    t26 = <div className="md:flex md:flex-row md:gap md:mt-2">{t23}{t25}</div>;
    $[42] = t23;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== t21 || $[45] !== t26 || $[46] !== t3) {
    t27 = <FixedWidthContainer wide={true} noMobilePadding={true} noPadding={t3}>{t21}{t26}</FixedWidthContainer>;
    $[44] = t21;
    $[45] = t26;
    $[46] = t3;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  const t28 = pageData?.pageId;
  let t29;
  if ($[48] !== t28) {
    t29 = <ProductListingPageWidgets categoryId={t28} />;
    $[48] = t28;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== pageData || $[51] !== t2 || $[52] !== t27 || $[53] !== t29) {
    t30 = <ProductListingPageContext.Provider value={pageData}>{t2}{t27}{t29}</ProductListingPageContext.Provider>;
    $[50] = pageData;
    $[51] = t2;
    $[52] = t27;
    $[53] = t29;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  return t30;
};
ProductListingPage.propTypes = {
  pageData: PropTypes.shape({
    filters: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string
      }))
    })),
    filterStateKey: PropTypes.string,
    loading: PropTypes.bool,
    loadMoreClickCount: PropTypes.number,
    loadMoreProducts: PropTypes.func,
    isAllDataLoading: PropTypes.bool,
    isFinalProductCountKnown: PropTypes.bool,
    pageId: PropTypes.number,
    pageName: PropTypes.string,
    pageLongDescription: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      initialOptionId: PropTypes.string,
      name: PropTypes.string,
      onDisplayInShowroomSlug: PropTypes.string,
      path: PropTypes.string,
      productLabel: PropTypes.string,
      quickship: PropTypes.bool,
      secondaryImage: PropTypes.string,
      secondaryImageCropData: PropTypes.object,
      variants: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        image: PropTypes.string,
        minPrice: PropTypes.number,
        originalPrice: PropTypes.number,
        path: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        quickship: PropTypes.bool
      })),
      variantsTotal: PropTypes.number
    })),
    resetFilters: PropTypes.func,
    setSortOrder: PropTypes.func,
    showLoadMoreButton: PropTypes.bool,
    sortOrder: PropTypes.string,
    toggleFilter: PropTypes.func,
    toggleFilterOption: PropTypes.func,
    totalProductCount: PropTypes.number
  }),
  sidebarHeader: PropTypes.node,
  pageHeaderOverride: PropTypes.node,
  // True on the descriptor-sourced listings, where the consumer app's catch-all
  // generateMetadata is the only emitter of title, description and Open Graph
  // (CON-8801). Search results leave it unset and keep the Helmet copy.
  serverOwnsSeoTags: PropTypes.bool,
  variant: PropTypes.oneOf(['advanced-search'])
};
export default ProductListingPage;
function _temp(prevIsOpen) {
  return !prevIsOpen;
}